
export const giantFont = { font: 'gothic_ultra_otregular, fantasy', size: 72, color: 'white', align: 'center' };
export const largeFont = { font: 'gothic_ultra_otregular, fantasy', size: 48, color: 'white', align: 'center' };
export const mediumFont = { font: 'gothic_ultra_otregular, fantasy', size: 32, color: 'white', align: 'center' };
export const smallFont = { font: 'gothic_ultra_otregular, fantasy', size: 24, color: 'white', align: 'center' };
export const monoFont = { font: 'monospace', size: 24, color: 'white', align: 'center' };



/** WEBPACK FOOTER **
 ** ./src/ui.js
 **/